import filterproduct1 from "../../../images/productsImages/filterImages/Residencial/carcasas/bigblue.jpg";
import filterproduct2 from "../../../images/productsImages/filterImages/Residencial/carcasas/blanco.png";
import filterproduct3 from "../../../images/productsImages/filterImages/Residencial/carcasas/transparentes.jpg";
import filterproduct4 from "../../../images/productsImages/filterImages/Residencial/cartuchos/carbon.jpg";
import filterproduct5 from "../../../images/productsImages/filterImages/Residencial/cartuchos/poli.jpg";
import filterproduct6 from "../../../images/productsImages/filterImages/Residencial/sistemas/kitgrande.jpg";
import filterproduct7 from "../../../images/productsImages/filterImages/Residencial/sistemas/inox.jpg";

import filterpdf1 from "../../../pdf/filter/Bigblue.pdf";
import filterpdf2 from "../../../pdf/filter/ClearUp.pdf";
import filterpdf3 from "../../../pdf/filter/Transparente.pdf";
import filterpdf4 from "../../../pdf/filter/CarbonoactivoBGP.pdf";
import filterpdf5 from "../../../pdf/filter/sedimentosBGP.pdf";
import filterpdf6 from "../../../pdf/filter/Purificador.pdf";
import filterpdf7 from "../../../pdf/filter/PURIFICADORINOX.pdf";

const filterResidentialProductList = [
  {
    _id: "filtcatresideprod001",
    image: filterproduct1,
    title: "Carcasa de filtro Big Blue serie BB",
    code: "",
    category: "Carcasa",
    brand: "BGP",
    downLoad: filterpdf1,
  },
  {
    _id: "filtcatresideprod002",
    image: filterproduct2,
    title: "Carcasa de filtro blanco serie BW",
    code: "",
    category: "Carcasa",
    brand: "BGP",
    downLoad: filterpdf2,
  },
  {
    _id: "filtcatresideprod003",
    image: filterproduct3,
    title: "Carcasa de filtro transparente serie BT”",
    code: "",
    category: "Carcasa",
    brand: "BGP",
    downLoad: filterpdf3,
  },
  {
    _id: "filtcatresideprod004",
    image: filterproduct4,
    title: "Cartucho para filtro carbón activado",
    code: "",
    category: "Elementos Filtrantes",
    brand: "BGP",
    downLoad: filterpdf4,
  },
  {
    _id: "filtcatresideprod005",
    image: filterproduct5,
    title: "Cartucho para filtro de sedimentos",
    code: "",
    category: "Elementos Filtrantes",
    brand: "BGP",
    downLoad: filterpdf5,
  },
  {
    _id: "filtcatresideprod006",
    image: filterproduct6,
    title: "Kit purificador de osmosis inversa 5 etapas",
    code: "",
    category: "Sistemas de filtrado",
    brand: "BGP",
    downLoad: filterpdf6,
  },
  {
    _id: "filtcatresideprod007",
    image: filterproduct7,
    title: "Kit purificador de osmosis inversa 5 etapas inox",
    code: "",
    category: "Sistemas de filtrado",
    brand: "BGP",
    downLoad: filterpdf7,
  },
];

export default filterResidentialProductList;
